import { Component } from "react";
import auth from "../services/authService";

class Logout extends Component {
  componentDidMount() {
    localStorage.removeItem("userName");
    auth.logout();

    window.location = "/login";
  }

  render() {
    return null;
  }
}

export default Logout;



// WEBPACK FOOTER //
// ./src/components/logout.jsx